import React, { useState } from "react";
import { useAuth } from "../context/AuthContext";
import { useNavigate } from "react-router-dom";
import Header from "../components/Header";
import AudioRecorder from "../components/AudioRecorder";
import CuppingsList from "../components/CuppingsList";
import "./Dashboard.css";

const Dashboard = () => {
  const { user, logout } = useAuth();
  const navigate = useNavigate();
  const [refreshTrigger, setRefreshTrigger] = useState(0);

  const handleLogout = async () => {
    await logout();
    navigate("/login");
  };

  const handleUploadSuccess = (result) => {
    // Trigger refresh of cuppings list
    setRefreshTrigger((prev) => prev + 1);
  };

  return (
    <div className="dashboard-container">
      <Header user={user} onLogout={handleLogout} />

      <main className="dashboard-content">
        <section className="recorder-section">
          <h2>New Entry</h2>
          <AudioRecorder onUpload={handleUploadSuccess} />
        </section>

        <CuppingsList refreshTrigger={refreshTrigger} />
      </main>
    </div>
  );
};

export default Dashboard;
